var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallDiamondIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13049 2.73438L4.93437 5.8334L7.00039 12.2659M7.00039 12.2659L9.12078 5.77904L7.97903 2.73438M7.00039 12.2659L1.40039 5.88777M7.00039 12.2659L12.6004 5.88777M1.40039 5.88777L3.79262 2.73438H10.2625L12.6004 5.88777M1.40039 5.88777H12.6004",
    stroke: "#40D2FF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDiamondIcon);
export default __webpack_public_path__ + "static/media/small_diamond_icon.703abc95aa9ad0b8649e6a85f33a64f7.svg";
export { ForwardRef as ReactComponent };